import './otherresources.component.scss';
import { IMAGES_REPO } from '../../../static-resources';
const OtherResourcesComponent = () => {
  return (
    <>
      <div className="menusub-title">Other Resources</div>
      <ul className="megamenu-components">
        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.FlagIcon} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href="/training/release-notes">Release Notes</a>
                </h6>
                <p>
                  The latest industry news, interviews, technologies, and
                  resources
                </p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.Play} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>Demos</h6>
                <p>Coming Soon</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.BookOpen} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href="/training">Training</a>
                </h6>
                <p>
                  The latest industry news, interviews, technologies, and
                  resources
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </>
  );
};
export default OtherResourcesComponent;
